import React from 'react';
import PropTypes from 'prop-types';
import { Heading, Text, Anchor } from 'wt-ui';
import API from '../../services/API';
/* global newrelic */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error(error, errorInfo);
    newrelic.noticeError(error);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return (
        <>
          <Heading level={3}>Oops! Something went wrong.</Heading>
          <Text>
            Plase realod the page to restart the app, or{' '}
            <Anchor href={API.getContactUrl()} secondary weight="600" target="_blank">
              contact us
            </Anchor>{' '}
            if the problem persists.
          </Text>
        </>
      );
    }
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default ErrorBoundary;
